import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, Typography, Button, Flex } from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"
import { spacings } from "themes/variables"

const { Text } = Typography

export const CrewMemberTable = ({ data, onEdit, onRemove }) => {
  // Memoize columns to prevent recreation on every render
  const columns = useMemo(
    () => [
      {
        title: "Staff Member Name",
        dataIndex: "name",
        key: "name",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Text fw="500">
            {record.name || `${record.first_name || ""} ${record.last_name || ""}`.trim() || "-"}
          </Text>
        )
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        align: "left",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (role) => <Text>{role?.name || "-"}</Text>
      },
      {
        title: "Actions",
        key: "action",
        align: "right",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Flex gap={spacings.XS} justify="end">
            <Button
              type="text"
              icon={<EditOutlined className={styles.editIcon} />}
              onClick={() => onEdit(record)}
              aria-label="Edit crew member"
            />
            <Button
              type="text"
              icon={<DeleteOutlined className={styles.deleteIcon} />}
              onClick={() => onRemove(record.id)}
              className={styles.removeExperienceButton}
              aria-label="Remove crew member"
            />
          </Flex>
        )
      }
    ],
    [onEdit, onRemove]
  )

  return <Table className={styles.crewMemberTable} dataSource={data} rowKey="id" pagination={false} columns={columns} scroll={{ y: 300 }} />
}

CrewMemberTable.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}
